function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import { isObject } from 'fela-utils';

function embedded(style, type, renderer) {
  var _loop = function _loop(property) {
    var value = style[property];

    if (property === 'fontFace' && isObject(value)) {
      var fontFamily = value.fontFamily,
          src = value.src,
          otherProps = _objectWithoutProperties(value, ['fontFamily', 'src']);

      if (typeof fontFamily === 'string' && Array.isArray(src)) {
        style.fontFamily = renderer.renderFont(fontFamily, src, otherProps);
        delete style.fontFace;
      } else {
        // TODO: warning - invalid font data
      }
    } else if (property === 'animationName' && isObject(value)) {
      style[property] = renderer.renderKeyframe(function () {
        return value;
      });
    } else if (isObject(value)) {
      embedded(value, type, renderer);
    }
  };

  for (var property in style) {
    _loop(property);
  }

  return style;
}

export default (function () {
  return embedded;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-embedded/es/index.js
// module id = 781
// module chunks = 0